// extracted by mini-css-extract-plugin
export default {"dropdownButtonOpen":"DropdownButton_dropdownButtonOpen__2SO0c","dropdownButtonClosed":"DropdownButton_dropdownButtonClosed__s-N2s","carrot":"DropdownButton_carrot__+LnEU"};